export const DOCUMENT_CENTER = 'Document Center';
export const VIEW_YOUR_PLAN = 'View your plan documents, all in one place.';
export const EXPLANATION_OF_BENEFITS = 'Explanation of Benefits';
export const FOR = 'For';
export const OPEN_ERROR_MODAL = 'Open Error Modal';
export const WENT_WRONG = 'Oops! Something went wrong.';
export const ERROR_MESSAGE = 'We’re sorry, but an unexpected error has occured';
export const PLEASE_TRY_AGAIN = 'Please try again';
export const OK = 'OK';
export const FONT_ROBOTO =
  "Roboto, BlinkMacSystemFont, -apple-system, 'Segoe UI', Helvetica, Arial, sans-serif";
export const FONT_POPPINS =
  "Poppins, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";
export const RECENT_DOCUMENTS = 'Recent Documents';
export const ALL_DOCUMENTS = 'All Documents';
export const NO_DOCUMENTS_AVAILABLE = 'No documents available';
export const NO_DOCS_CONTENT =
  'See documents from the past two years here. For any additional support, please contact our support team via Live Chat.';
export const ALL_CONTENT =
  'This document helps you understand what costs your insurance plan covered, and what you may still be responsible for.';
export const SEE_ALL = 'See All Explanation of Benefits';
export const RECENT = 'recent';
export const ALL = 'All';
export const NO_RECENT_DOCUMENTS = 'No recent documents';
export const NO_RECENT_DOCS_CONTENT =
  'You don’t have any plan documents from the past 90 days. To view all your documents, check the “All Documents” tab. If you need additional support, please contact our support team via live chat.';
export const CHAT_NOW = 'Chat Now';
export const ALL_EOB_CONTENT =
  'This document explains what your insurance covered and costs you may be responsible for. View documents from the last two years below.';
export const ENGEN = 'engen';
export const EOB = 'eob';
export const DETERMINATION_NOTICES = 'determination-notices';
export const DETERMINATION_NOTICES_TITLE = 'Determination Notices';
export const DETERMINATION_NOTICES_DOCUMENT = 'determination_notices';
export const EXPLANATION_OF_BENEFITS_DOCUMENT = 'explanation_of_benefits';
export const DOCUMENTS_URL = '/documents';
